module.exports = __webpack_public_path__ + "static/img/装饰16.933d61f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰16.svg
// module id = fOEm
// module chunks = 2